var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadOutline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 9.70715C17.6835 10.0977 18.3167 10.0976 18.7072 9.70706C19.0977 9.31651 19.0976 8.68335 18.7071 8.29285L12.7063 2.29285C12.3158 1.90237 11.6826 1.90239 11.2921 2.29289L5.29212 8.29289C4.9016 8.68342 4.9016 9.31658 5.29212 9.70711C5.68265 10.0976 6.31581 10.0976 6.70634 9.70711L10.9992 5.41421V17C10.9992 17.5523 11.4469 18 11.9992 18C12.5515 18 12.9992 17.5523 12.9992 17V5.41399L17.2929 9.70715Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.999 20L4.99902 20C4.44674 20 3.99902 20.4477 3.99902 21C3.99902 21.5523 4.44674 22 4.99902 22L18.999 22C19.5513 22 19.999 21.5523 19.999 21C19.999 20.4477 19.5513 20 18.999 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOutline2);
export default __webpack_public_path__ + "static/media/upload_outline (2).5cb5f61102018c6de1317609a99bd17b.svg";
export { ForwardRef as ReactComponent };